module.exports = __webpack_public_path__ + "img/xmsb4.793d4e75.png";